/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PlusIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PlusIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PlusIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 8,
  height = 8,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PlusIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 8 8"
 style={{'--as-1-vxirM': alignSelf,'--mt-2-vxirM': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-vxirM': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-vxirM': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-vxirM': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-vxirM': opacity,'--w-10-vxirM': typeof width === 'number' ? `${width}px` : width,'--h-11-vxirM': typeof height === 'number' ? `${height}px` : height,'--f-12-vxirM': fill,'--a-7-vxirM': isAnimated ? animation : "none",'--sd-8-vxirM': isAnimated ? strokeDashoffset : 0,'--sd-9-vxirM': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PlusIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4 .25a.75.75 0 01.75.75v2.25H7a.75.75 0 010 1.5H4.75V7a.75.75 0 01-1.5 0V4.75H1a.75.75 0 010-1.5h2.25V1A.75.75 0 014 .25z"
 style={{'--f-12-vxirM': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}